const cn = (classes) => classes
  .filter(Boolean)
  .join(' ');

export default cn;
